import { getTemplateRoles } from '@modusign/openapi-client-template';
import {
  GetTemplateRolesParams,
  GetTemplateRolesResponseDto,
} from '@modusign/openapi-client-template/generated/model';
import { useQuery, UseQueryOptions } from 'react-query';

import { useWorkspaceId } from '@app/hooks/useWorkspaceId';

interface UseTemplateEditionPermissionParams {
  templateId?: string;
  param?: GetTemplateRolesParams;
}

export type TemplateResourceRoleResponseOptions = UseQueryOptions<
  GetTemplateRolesResponseDto,
  Error
>;

export function useTemplateResourceRole(
  { templateId, param }: UseTemplateEditionPermissionParams,
  options?: TemplateResourceRoleResponseOptions
) {
  const workspaceId = useWorkspaceId();

  const queryKey = ['templateResourceRole', workspaceId, templateId];
  return useQuery<GetTemplateRolesResponseDto, Error>(
    queryKey,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    () => getTemplateRoles(workspaceId, templateId!, param),
    {
      enabled: !!workspaceId && !!templateId,
      staleTime: 1000,
      ...options,
    }
  );
}
